import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'

import { File } from 'bundles/Pilot/types'

type Props = {
  file: File
}

function FileThumbnail({ file }: Props) {
  return (
    <div className='ms-2'>
      <a href={file.showPath}>
        <FontAwesomeIcon icon={faDownload} className='me-2' />
        {file.name}
      </a>
    </div>
  )
}

export default FileThumbnail
